import { render, staticRenderFns } from "./PriceSlider.vue?vue&type=template&id=80d1b428&"
import script from "./PriceSlider.vue?vue&type=script&lang=ts&"
export * from "./PriceSlider.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseRangeSlider: require('/home/vsts/work/1/a/NuxtApp/components/base/range-slider/index.vue').default,BaseRangeSliderInputNumber: require('/home/vsts/work/1/a/NuxtApp/components/base/range-slider/InputNumber.vue').default})
